<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.username" placeholder="用户名" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-input v-model="listQuery.module" placeholder="模块" style="width: 200px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        class="filter-item"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
      <el-button class="filter-item" type="success" icon="el-icon-download" @click="handleExport">导出</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="日志ID" prop="logId" align="center" width="80" />
      <el-table-column label="用户名" prop="username" align="center" width="120" />
      <el-table-column label="操作" prop="operation" align="center" />
      <el-table-column label="模块" prop="module" align="center" width="120" />
      <el-table-column label="目标对象" prop="targetName" align="center" />
      <el-table-column label="请求URL" prop="requestUrl" align="center" show-overflow-tooltip />
      <el-table-column label="请求方法" prop="requestMethod" align="center" width="100" />
      <el-table-column label="IP地址" prop="ipAddress" align="center" width="120" />
      <el-table-column label="结果" prop="result" align="center" width="100">
        <template slot-scope="{row}">
          <el-tag :type="row.result === 'success' ? 'success' : 'danger'">{{ row.result }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="耗时(ms)" prop="duration" align="center" width="100" />
      <el-table-column label="创建时间" prop="createdAt" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.createdAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="100">
        <template slot-scope="{row}">
          <el-button type="text" size="mini" @click="handleDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog title="日志详情" :visible.sync="dialogVisible" width="60%">
      <el-form label-position="left" label-width="100px">
        <el-form-item label="日志ID">
          <span>{{ logDetail.logId }}</span>
        </el-form-item>
        <el-form-item label="用户名">
          <span>{{ logDetail.username }}</span>
        </el-form-item>
        <el-form-item label="操作">
          <span>{{ logDetail.operation }}</span>
        </el-form-item>
        <el-form-item label="模块">
          <span>{{ logDetail.module }}</span>
        </el-form-item>
        <el-form-item label="请求URL">
          <span>{{ logDetail.requestUrl }}</span>
        </el-form-item>
        <el-form-item label="请求方法">
          <span>{{ logDetail.requestMethod }}</span>
        </el-form-item>
        <el-form-item label="IP地址">
          <span>{{ logDetail.ipAddress }}</span>
        </el-form-item>
        <el-form-item label="User Agent">
          <span>{{ logDetail.userAgent }}</span>
        </el-form-item>
        <el-form-item label="结果">
          <span>{{ logDetail.result }}</span>
        </el-form-item>
        <el-form-item label="错误信息" v-if="logDetail.errorMsg">
          <span style="color: red;">{{ logDetail.errorMsg }}</span>
        </el-form-item>
        <el-form-item label="耗时">
          <span>{{ logDetail.duration }} ms</span>
        </el-form-item>
        <el-form-item label="创建时间">
          <span>{{ logDetail.createdAt | parseTime }}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { listLogs, getLog, exportLogs } from '@/api/operationLog'
import Pagination from '@/components/Pagination'

export default {
  name: 'SystemLog',
  components: { Pagination },
  filters: {
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        username: undefined,
        module: undefined,
        startDate: undefined,
        endDate: undefined
      },
      dateRange: [],
      dialogVisible: false,
      logDetail: {}
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.startDate = this.dateRange[0]
        this.listQuery.endDate = this.dateRange[1]
      }
      listLogs(this.listQuery).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleDetail(row) {
      getLog(row.logId).then(response => {
        this.logDetail = response.data
        this.dialogVisible = true
      })
    },
    handleExport() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.listQuery.startDate = this.dateRange[0]
        this.listQuery.endDate = this.dateRange[1]
      }
      exportLogs(this.listQuery).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'operation_logs.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
</style>
